import ChooseCardColor from './ChooseCardColor';

export default ChooseCardColor;
